<template>
  <article class="popup popup-padding add-permission-project">
    <header class="popup-top">
      <h2 class="title">
        {{$t('projects.project.share')}}
      </h2>
      <div class="popup-top_btns">
        <question-btn :text="$t('prompts.openAccess')"></question-btn>
        <close-btn class="static"></close-btn>
      </div>
    </header>
    <form class="add-permission-form" @submit.prevent="addRoles">
      <div v-if="isRoleType"
           class="select-cont select-cont_multiple">
        <p class="label">
          {{$t('projects.project.share')}}
        </p>
        <v-select multiple
                  :searchable="true"
                  v-model="roles"
                  :clearable="false"
                  label="name"
                  :options="rolesArr"></v-select>
      </div>

      <div v-if="isUserType"
           class="select-cont select-cont_multiple">
        <p class="label">
          {{$t('projects.project.share')}}
        </p>

        <v-select taggable
                  multiple
                  push-tags
                  :searchable="true"
                  v-model="users"
                  :clearable="false"
                  label="email"
                  :options="usersArr"></v-select>
      </div>

      <permission-toggler @level="level = $event"
                          :default-val="1"
                          v-if="isRoleType"
                          class="permission-toggler"></permission-toggler>
      <div class="btns-bottom">
        <button type="button"
                :disabled="loading"
                @click="closeAll"
                class="btn btn-transparent_blue">{{$t('btns.cancel')}}</button>
        <button type="submit"
                :disabled="loading || disabled"
                :class="{'loading': loading}"
                class="btn btn-blue">{{$t('btns.invite')}}</button>
      </div>
    </form>
  </article>
</template>

<script>
  import closeBtn from '../closeBtn'
  import questionBtn from '../questionBtn'
  import permissionToggler from '../../permissionToggler'
  import {usersInAccount} from "../../../mixins/utils/usersInAccount";
  import {popups} from "../../../mixins/popups";
  import {mapState, mapMutations, mapActions} from 'vuex'

  export default {
    name: 'addPermissionProject',
    mixins: [usersInAccount, popups],
    components: {
      permissionToggler,
      closeBtn,
      questionBtn
    },
    data() {
      return {
        level: 1,
        roles: [],
        users: [],
        loading: false
      }
    },
    computed: {
      ...mapState({
        addPermissionType: state => state.projects.addPermissionType
      }),
      disabled() {
        if (this.isRoleType) {
         return this.roles.length < 1
        };

        if (this.isUserType) {
          return this.users.length < 1
        }
      },
      isRoleType() {
        return this.addPermissionType === 'role'
      },
      isUserType() {
        return this.addPermissionType === 'user'
      }
    },
    methods: {
      ...mapMutations({
        setPermissionType: 'projects/SET_ADD_PERMISSION_TYPE'
      }),
      ...mapActions({
        setPermissions: 'projects/setPermissions',
        getProject: 'projects/getProject'
      }),
      async addRoles() {

        let obj = {
          value: this.level,
        };

        if (this.isRoleType) {
          addRoles(this);
        }

        if (this.isUserType) {
          addUsers(this);
          obj.value = 4
        }

        if (this.$route.name.includes('projectItem')) {
          addProjectItemId(this)
        } else {
          addProjectId(this);
        }

        await this.setPermissions({data: obj, id: this.$route.params.id})
          .then(() => {

            if (this.isUserType || this.$route.params.id) {
              this.getProject(this.$route.params.id)
            }
            this.closeAll()

          });

        function addRoles(cntx) {
          obj.roles_ids = cntx.roles.map(item => item.id).join(',');
        }

        function addUsers(cntx) {
          cntx.users.forEach((item, index) => {
            if (!item.email) {
              cntx.users[index] = {email: item}
            }
          })
          obj.emails = cntx.users.map(item => item.email).join(',')
        }

        function addProjectId(cntx) {
          obj.project_id = cntx.$route.params.id
        }

        function addProjectItemId(cntx) {
          obj.project_item_id = cntx.$route.params.item
        }
      }
    },
    destroyed() {
      this.setPermissionType('role')
    }
  }
</script>

<style lang="scss" scoped>
.permission-toggler {
  margin: 15px 0;
}
</style>
